<template lang="pug">
#carrosel-clima-monitoramento-agricola
    .slider-clima
        span.handle.handlePrev.active(
            @mouseover='scrollEsquerda()',
            @mouseout='limparScroll()'
        )
            i.mdi.mdi-arrow-left-circle

        #scroller.slider-clima__lista
            .slider-clima__lista__interno
                .slider-clima__lista__interno__dados(
                    v-for='(previsao, index) in previsoesClimaticas',
                    :key='index'
                )
                    .slider-clima__lista__interno__dados-alinhar
                        span.slider-clima__lista__interno__dados-alinhar__icone.lyra-icon(
                            :class='[retornaIconePrecipitacao(previsao.precipitacao.valor)]'
                        )
                        span.slider-clima__lista__interno__dados-alinhar__negrito {{ internacionalizacaoDiasSemana(previsao.precipitacao.dia) }}
                        span.slider-clima__lista__interno__dados-alinhar__negrito {{ previsao.precipitacao.data }}
                    .slider-clima__lista__interno__dados__ajustar
                        .slider-clima__lista__interno__dados-alinhar__divisoria
                            span {{ $t('mensagens.monitoramentoAgricola.temperatura') }}
                            span.mdi.mdi-arrow-down {{ previsao.minima }}º
                            span.mdi.mdi-arrow-up {{ previsao.maxima }}º
                        .slider-clima__lista__interno__dados-alinhar__divisoria
                            span {{ $t('mensagens.monitoramentoAgricola.chuva') }}
                            .slider-clima__lista__interno__dados-alinhar__divisoria-icone
                                span.mdi.mdi-water
                                span.mdi.mdi-water
                                span.mdi.mdi-water.gota-cinza
                                span.espaco-esquerdo {{ previsao.precipitacao.valor }}mm

        span.handle.handleNext.active(
            @mouseover='scrollDireita()',
            @mouseout='limparScroll()'
        )
            i.mdi.mdi-arrow-right-circle
</template>
<script>
import MonitoramentoService from '@/services/MonitoramentoService';
import formatters from '@/utils/formatters';
export default {
    name: 'CarroselClimaMonitoramentoAgricola',
    data() {
        return {
            intervalo: 0,
            dadosClimaticos: null,
            isLoading: false,
            previsoesClimaticas: []
        };
    },
    mounted() {
        this.isLoading = true;
        MonitoramentoService.monitoramentoClimatico(this.$route.params.id)
            .then(({ data }) => {
                this.dadosClimaticos = data.dados;
                this.configure();
            })
            .catch(() => {
                this.$notify.error({
                    message: this.$t('mensagens.monitoramento.historico.agricola.ocorreuUmErroAoBuscarDadosClimaticos')
                });
            })
            .finally(() => {
                this.isLoading = false;
            });
    },
    methods: {
        scrollDireita: function () {
            this.intervalo = setInterval(function () {
                document.getElementById('scroller').scrollLeft += 2;
            }, 5);
        },
        scrollEsquerda: function () {
            this.intervalo = setInterval(function () {
                document.getElementById('scroller').scrollLeft -= 2;
            }, 5);
        },
        limparScroll: function () {
            clearInterval(this.intervalo);
        },

        configure() {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const dadosPrecipitacao = this.dadosClimaticos
                .find(d => d.tipo === 'PRECIPITACAO')
                .dados.filter(d => new Date(d.data) >= today);

            const dadosTemperaturaMaxima = this.dadosClimaticos.find(
                d => d.tipo === 'TEMPERATURA_MAXIMA'
            ).dados;

            const dadosTemperaturaMinima = this.dadosClimaticos.find(
                d => d.tipo === 'TEMPERATURA_MINIMA'
            ).dados;

            this.previsoesClimaticas = dadosPrecipitacao.map(previsao => ({
                precipitacao: {
                    data: new Date(previsao.data).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }),
                    dia:
                        formatters.dateStringToDayName(
                            new Date(previsao.data)
                                .toLocaleDateString('pt-BR')
                                .split('/')
                                .reverse()
                                .join('-')
                        ),
                    valor: Math.round(previsao.valor)
                },
                maxima: Math.round(
                    dadosTemperaturaMaxima.filter(
                        m => m.data === previsao.data
                    )[0].valor
                ),
                minima: Math.round(
                    dadosTemperaturaMinima.filter(
                        m => m.data === previsao.data
                    )[0].valor
                )
            }));
        },
        retornaIconePrecipitacao(precipitacao) {
            if (precipitacao < 25) {
                return 'lyra-sol';
            } else if (precipitacao >= 25 && precipitacao < 40) {
                return 'lyra-nuvem';
            } else {
                return 'lyra-chuva';
            }
        },
        internacionalizacaoDiasSemana(data) {
            const dataFormatada = data.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
            return this.$t(`mensagens.monitoramentoAgricola.diasTemperatura.${dataFormatada}`);
        }
    }
};
</script>

<style lang="scss" scoped>
#carrosel-clima-monitoramento-agricola {
    .slider-clima {
        position: relative;
        margin: 0;
        padding: 0 4%;
        -ms-touch-action: pan-y;
        touch-action: pan-y;

        .handle.handlePrev {
            left: 0;
        }
        .handle.handleNext {
            right: 0;
        }
        .handle.active {
            cursor: pointer;
            display: flex;
            align-items: center;
            font-size: 23px;
        }
        .handle {
            position: absolute;
            top: 0;
            bottom: 0;
            z-index: 20;
            width: 2%;
            text-align: center;
            -webkit-box-pack: center;
            -webkit-justify-content: center;
            -moz-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            color: var(--white);
        }

        &__lista {
            overflow: hidden;

            &__interno {
                -webkit-transition: 450ms -webkit-transform;
                transition: 450ms -webkit-transform;
                transition: 450ms transform;
                transition: 450ms transform, 450ms -webkit-transform;
                font-size: 0;
                white-space: nowrap;
                margin: 8px 0;
                padding-bottom: 10px;
                display: flex;

                &__dados {
                    position: relative;
                    display: flex;
                    width: 276px;
                    height: 110px;
                    background: var(--white);
                    box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
                    border-radius: 5px;
                    margin-right: 10px;
                    font-size: 20px;
                    -webkit-transition: 450ms all;
                    transition: 450ms all;
                    -webkit-transform-origin: center left;
                    transform-origin: center left;
                    padding: 10px;
                    justify-content: space-between;
                    &__ajustar {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 180px;
                    }

                    &-alinhar {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        border-right: 2px solid var(--secondary-two);
                        width: 74px;
                        padding-right: 10px;

                        &__negrito {
                            font-size: 14px;
                            font-weight: 600;
                        }
                        &__divisoria {
                            font-size: 14px;
                            font-weight: 400;
                            display: flex;
                            width: 165px;
                            justify-content: space-between;

                            .espaco-esquerdo {
                                margin-left: 2px;
                            }
                        }
                    }
                }
            }
        }
    }
    .lyra-icon::before {
        content: '';
        width: 36px;
        height: 36px;
        display: inline-block;
        background-color: var(--primary);
    }
    .mdi-arrow-down::before {
        content: '\F0045';
        color: #4fa3f8;
    }
    .mdi-arrow-up::before {
        content: '\F005D';
        color: #df675b;
    }
    .mdi-water::before {
        content: '\F058C';
        color: #4fa3f8;
    }
    .gota-cinza::before {
        color: var(--background-disabled) !important;
    }
    .mdi-arrow-right-circle::before {
        content: '\F0CDF';
        color: var(--background-disabled);
    }
    .mdi-arrow-right-circle:hover:before {
        content: '\F0CDF';
        color: var(--secondary-two);
    }
    .mdi-arrow-left-circle::before {
        content: '\F0CDD';
        color: var(--background-disabled);
    }
    .mdi-arrow-left-circle:hover:before {
        content: '\F0CDD';
        color: var(--secondary-two);
    }
}
</style>
